export default __webpack_public_path__ + "static/media/ColorShiftsClosed.862ab4f3.svg";